export enum RSVPFormField {
    name = 'name',
    email = 'email',
    attending = 'attending',
    companions = 'companions',
    hasFoodRestrictions = 'hasFoodRestrictions',
    foodRestrictionsText = 'foodRestrictionsText',
}